import(/* webpackMode: "eager" */ "/codebuild/output/src36880211/src/apps/fanychance/src/app/error.tsx");
